// import tippy from "tippy.js";
//
// $(document).ready(function () {
//
//     var helpers = (function () {

export default class Helpers {

    constructor() {
        this.init();
    }


    init() {
        // addEventListeners();

        this.addEventListeners();

        return;
    }

    addEventListeners() {

        $('.js-section-toggle').on('click', this.handleSectionToggle);
        $('.js-form-reset').on('click', this.handleFormReset);
    }

    handleSectionToggle(event) {
        $(this).toggleClass('closed');
        $(this).find(' + .page-section > .page-section__inside').slideToggle();
    }

    handleFormReset(event) {
        event.preventDefault();
        let formId = $(this).parents('form').attr('id');
        $('form#' + formId + ' input[name="sent"]').val('2');
        $('#' + formId).submit();
    }
};

//         return {
//             init: init
//         }
//
//     })();
//
//     helpers.init();
//
// });



